export const paginationContainerStyle = {
    bgColor: 'white',
    p: '8px 24px',
    border: '1px solid',
    borderColor: 'gray.100',
    borderBottomRadius: '8px',
    justifyContent: 'space-between',
    boxShadow: 'base',
};
